import React from 'react';
import CloseButtonDialog from '../../views/common/CloseButtonDialog';
import {
  enablePageScroll,
  disablePageScroll,
} from '../../common/utils/uiHelper';

export default class AppErrorInfoDialog extends React.Component {
  constructor(props) {
    super(props);
    this.state = { open: false, errorInfo: null };

    this.handleClose = this.handleClose.bind(this);
  }

  handleOpen(errorInfo) {
    disablePageScroll();
    this.setState({ open: true, errorInfo: errorInfo });
  }

  handleClose() {
    if (!this.state.open) {
      return;
    }

    enablePageScroll();
    this.props.showAppError(null);
    this.setState({ open: false, errorInfo: null });
  }

  renderErrorMessage() {
    return (
      <div className="h5 red text-wrap pl1 capitalize-first-letter">
        {this.state.errorInfo.message}
      </div>
    );
  }

  render() {
    return (
      <div className="col-12">
        <CloseButtonDialog
          open={this.state.open}
          modal={false}
          title={
            <div className="h4">
              {this.state.errorInfo && this.state.errorInfo.title}
            </div>
          }
          autoScrollBodyContent
          contentStyle={{ margin: ' auto', maxWidth: '100%', width: '50%' }}
          onRequestClose={this.handleClose}
        >
          {this.state.errorInfo && this.renderErrorMessage()}
        </CloseButtonDialog>
      </div>
    );
  }
}
